@if (!hideAll()() && selectedInvoice) {
	<div *transloco="let t" [class]="dialogMode() ? '' : 'p-4'">
		@if (!dialogMode()) {
			<h1 class="title mt-0 mb-4">{{ t('billing.invoice.title') }}</h1>
		}
		<div class="flex flex-col pl-2">
			<div class="flex items-center justify-start w-full">
				<span class="pr-3 flex-none">{{ t('billing.relatedCostGroup') }}</span>
				<hr class="w-full h-px my-0" />
			</div>
			<div class="flex flex-wrap justify-start items-center gap-2">
				<mat-form-field appearance="outline" class="w-96 p-2">
					<mat-label>{{ t('billing.name') }}</mat-label>
					<input [(ngModel)]="costGroup.name" matInput disabled placeholder="{{ t('billing.name') }}" />
				</mat-form-field>
				<mat-form-field appearance="outline" class="w-60 p-2">
					<mat-label>{{ t('billing.category') }}</mat-label>
					<mat-select
						[ngModel]="selectedInvoiceCategory.exportId"
						(ngModelChange)="selectedInvoiceCategory = { exportId: $event }"
						[disabled]="!!selectedInvoiceCategory?.exportId">
						@for (category of costGroup.invoiceCategories; track category.exportId) {
							<mat-option [value]="category.exportId">
								{{ t('enum.' + category.type) }}
							</mat-option>
						}
					</mat-select>
				</mat-form-field>
			</div>

			<div class="flex items-center justify-start w-auto">
				<span class="pr-3 flex-none">{{ t('billing.invoice.invoice') }}</span>
				<hr class="w-full h-px my-0" />
			</div>
			<div class="flex flex-wrap justify-start items-center gap-2">
				<mat-form-field appearance="outline" class="w-96 p-2">
					<mat-label>Rechnungsname (Lieferant, Anbieter, Beschreibung)</mat-label>
					<input [(ngModel)]="selectedInvoice.name" matInput required placeholder="Rechnungsname (Lieferant, Anbieter, Beschreibung)" />
				</mat-form-field>
				<mat-form-field appearance="outline" class="w-60 p-2">
					<mat-label>{{ t('billing.invoice.date') }}</mat-label>
					<input
						[ngModel]="serviceDate()"
						(ngModelChange)="serviceDate.set($event)"
						[matDatepicker]="dp"
						[min]="minDate"
						[max]="maxDate"
						required
						matInput />
					<div matSuffix class="flex items-center">
						@if (serviceDate()?.isValid()) {
							<mat-datepicker-toggle>
								<mat-icon matDatepickerToggleIcon (click)="serviceDate.set(undefined)">clear</mat-icon>
							</mat-datepicker-toggle>
						}
						<mat-datepicker-toggle [for]="dp" matSuffix></mat-datepicker-toggle>
					</div>
					<mat-datepicker #dp></mat-datepicker>
				</mat-form-field>
			</div>

			<div class="flex flex-wrap gap-4">
				@if (selectedInvoiceCategory.type !== InvoiceCategoryType.REMAINING_STOCK) {
					<div class="p-2">
						@if (invoiceAmounts().length > 0) {
							<div class="inline-block p-4 bg-gray-50 rounded-md shadow-lg border border-gray-200">
								<table class="table-auto border-collapse text-left">
									<thead class="text-left">
										<tr>
											<th class="w-60 px-1 pb-2">{{ t('billing.invoiceAmountValues') }}</th>
											@if (showNet()) {
												<th class="w-32 px-1 pb-2">
													{{ t('billing.net') }}
												</th>
												@if (showVat()) {
													<th class="w-24 px-1 pb-2">
														{{ t('billing.taxRate') }}
													</th>
													<th class="w-32 px-1 pb-2">
														{{ t('billing.vat') }}
													</th>
												}
											}
											@if (showGross()) {
												<th class="w-32 px-1 pb-2">
													{{ t('billing.gross') }}
												</th>
												@if (!showNet() && showVat()) {
													<th class="w-24 px-1 pb-2">
														{{ t('billing.taxRate') }}
													</th>
													<th class="w-32 px-1 pb-2">
														{{ t('billing.vat') }}
													</th>
												}
											}
										</tr>
									</thead>
									<tbody>
										@for (invoiceAmount of invoiceAmounts(); track invoiceAmount.exportId; let index = $index) {
											<tr>
												<td class="pr-2 pt-2 align-top">
													<div [innerHTML]="t('billing.invoiceAmountType.' + invoiceAmount.type)"></div>
												</td>
												@if (showNet()) {
													<td class="pr-2">
														<mat-form-field appearance="outline" class="w-40">
															<mat-label>{{ t('billing.invoiceAmountvalue.netAmount') }}</mat-label>
															<input
																[(ngModel)]="invoiceAmountValues()[index].netAmount"
																(ngModelChange)="onNetAmountChange(index, $event)"
																matInput
																inputmode="decimal"
																araDecimalFormat
																[placeholder]="t('billing.invoiceAmountvalue.netAmount')"
																required
																class="text-right" />
															<span matSuffix class="text-xl">€&nbsp;</span>
														</mat-form-field>
													</td>
													@if (showVat()) {
														<td class="pr-2">
															<mat-form-field appearance="outline" class="w-24">
																<input
																	[(ngModel)]="taxRates[index]"
																	(keyup)="onKeyUp($event, index)"
																	matInput
																	araDecimalFormat
																	readonly
																	size="3"
																	class="text-right" />
																<span matSuffix class="text-xl">%&nbsp;</span>
															</mat-form-field>
														</td>
														<td class="pr-2">
															<mat-form-field appearance="outline" class="w-40">
																<mat-label>{{ t('billing.invoiceAmountvalue.vatAmount') }}</mat-label>
																<input
																	[(ngModel)]="invoiceAmountValues()[index].vatAmount"
																	(ngModelChange)="onTaxAmountChange(index, $event)"
																	[disabled]="showNet() && !isValueSet(invoiceAmountValues()[index].netAmount)"
																	matInput
																	inputmode="decimal"
																	araDecimalFormat
																	[placeholder]="t('billing.invoiceAmountvalue.vatAmount')"
																	class="text-right" />
																<span matSuffix class="text-xl">€&nbsp;</span>
															</mat-form-field>
														</td>
													}
												}
												@if (showGross()) {
													<td class="pr-2">
														<mat-form-field appearance="outline" class="w-40">
															<mat-label>{{ t('billing.invoiceAmountvalue.grossAmount') }}</mat-label>
															<input
																matInput
																[(ngModel)]="invoiceAmountValues()[index].grossAmount"
																(ngModelChange)="onGrossAmountChange(index, $event)"
																[placeholder]="t('billing.invoiceAmountvalue.grossAmount')"
																[disabled]="showNet() && !isValueSet(invoiceAmountValues()[index].netAmount)"
																inputmode="decimal"
																araDecimalFormat
																required
																class="text-right" />
															<span matSuffix class="text-xl">€&nbsp;</span>
															<mat-error>
																{{ t('common.requiredField') }}
															</mat-error>
														</mat-form-field>
													</td>
													@if (!showNet() && showVat()) {
														<td class="pr-2">
															<mat-form-field appearance="outline" class="w-24">
																<input
																	[(ngModel)]="taxRates[index]"
																	(keyup)="onKeyUp($event, index)"
																	matInput
																	araDecimalFormat
																	readonly
																	size="3"
																	class="text-right" />
																<span matSuffix class="text-xl">%&nbsp;</span>
															</mat-form-field>
														</td>
														<td class="pr-2">
															<mat-form-field appearance="outline" class="w-40">
																<mat-label>{{ t('billing.invoiceAmountvalue.vatAmount') }}</mat-label>
																<input
																	[(ngModel)]="invoiceAmountValues()[index].vatAmount"
																	(ngModelChange)="onTaxAmountChange(index, $event)"
																	[disabled]="showNet() && !isValueSet(invoiceAmountValues()[index].netAmount)"
																	matInput
																	inputmode="decimal"
																	araDecimalFormat
																	[placeholder]="t('billing.invoiceAmountvalue.vatAmount')"
																	class="text-right" />
																<span matSuffix class="text-xl">€&nbsp;</span>
															</mat-form-field>
														</td>
													}
												}
											</tr>
										}
									</tbody>
								</table>
							</div>
						}
					</div>
				}
				@if (deliveries().length > 0) {
					<div class="p-2">
						<div class="inline-block p-4 bg-gray-50 rounded-md shadow-lg border border-gray-200">
							<table class="table-auto border-collapse w-auto text-left">
								<thead class="text_left">
									<tr>
										<th class="w-60 px-1 pb-2">{{ t('billing.deliveryValue') }}</th>
										<th class="w-32 px-1 pb-2">{{ t('billing.amount') }}</th>
										<th class="w-32 px-1 pb-2">{{ t('billing.unit') }}</th>
									</tr>
								</thead>
								<tbody>
									@for (currentDelivery of deliveries(); track currentDelivery.exportId; let index = $index) {
										<tr>
											<td class="pr-2 pt-2 align-top">
												<div [innerHTML]="t('commodity.' + currentDelivery.commodity)"></div>
												<!--                                                <div class="font-light text-xs text-gray-500"-->
												<!--                                                     [innerHTML]="t('billing.invoice.original') + ': ' + t(currentDelivery.name)">-->
												<!--                                                </div>-->
											</td>
											<td class="pr-2">
												<mat-form-field appearance="outline" class="w-40">
													<mat-label>{{ t('billing.amount') }}</mat-label>
													<input
														[(ngModel)]="deliveryValues()[index].amount"
														matInput
														araDecimalFormat
														[allowNegative]="false"
														[decimalFractionDigitsMin]="0"
														[decimalFractionDigitsMax]="2"
														placeholder="{{ t('billing.amount') }}"
														required
														class="text-right" />
													<mat-error>
														{{ t('common.requiredField') }}
													</mat-error>
												</mat-form-field>
											</td>
											<td class="pr-2">
												<mat-form-field appearance="outline" class="w-40">
													<mat-label>{{ t('billing.unit') }}</mat-label>
													<mat-select [(ngModel)]="deliveryValues()[index].unit">
														@for (category of costGroup.invoiceDeliveries; track category.exportId) {
															<mat-option [value]="category.physicalUnit">
																<div class="font-bold">
																	{{ t('enum.' + category.physicalUnit) }}
																</div>
															</mat-option>
														}
													</mat-select>
												</mat-form-field>
											</td>
										</tr>
									}
								</tbody>
							</table>
						</div>
					</div>
				}
			</div>
		</div>

		<ng-container>
			<div class="px-6 mb-4 flex flex-row justify-between items-center" mat-dialog-actions>
				<div class="flex items-center">
					@if (showVat()) {
						<mat-form-field appearance="outline" class="w-48">
							<mat-label>{{ t('billing.preferredVatRateShort') }}</mat-label>
							<mat-select [(ngModel)]="selectedVatRate" (ngModelChange)="onVatRateSelect($event)">
								<mat-select-trigger>{{ vatRateService.getVatRateTriggerLabel(selectedVatRate, VAT_RATE_OPTIONS) }}</mat-select-trigger>
								@for (option of VAT_RATE_OPTIONS; track option.value) {
									<mat-option [value]="option.value">
										<div class="flex flex-col">
											<span>{{ option.label }}</span>
											@if (option.hint) {
												<span class="text-xs text-gray-500">{{ t(option.hint) }}</span>
											}
										</div>
									</mat-option>
								}
							</mat-select>
						</mat-form-field>
					}
				</div>
				<div class="flex items-center">
					@if (selectedInvoice.exportId) {
						<button (click)="delete()" class="m-2" color="warn" mat-raised-button name="buttonClose" type="button">
							<mat-icon>delete</mat-icon>
							<span>
								{{ t('commonActions.delete') }}
							</span>
						</button>
					}
					<button (click)="cancel()" class="m-2" mat-raised-button name="buttonClose" type="button">
						<mat-icon>cancel</mat-icon>
						<span>
							{{ t('commonActions.cancel') }}
						</span>
					</button>
					<button (click)="save()" class="m-2" color="primary" mat-raised-button [disabled]="!isInvoiceValid()" type="submit">
						<mat-icon>save</mat-icon>
						<span>
							{{ t('commonActions.save') }}
						</span>
					</button>
				</div>
			</div>
		</ng-container>
	</div>
}
